import script from "./ProductionComponentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionComponentTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductionComponentTable.vue?vue&type=style&index=0&id=594ffe78&lang=css"

const __exports__ = script;

export default __exports__